<template>
  <v-container grid-list-xs>
    <v-dialog v-model="dialog" fullscreen transition="dialog-bottom-transition" :overlay="false">
      <v-card style="background-color:#F4F7FA;">
        <v-toolbar flat dark color="accent">
          <v-spacer></v-spacer>
          <span>Creación Usuario</span>
          <v-spacer></v-spacer>
          <v-toolbar-items>
            <v-btn icon @click.native="closeDialog()" dark>
              <v-icon>close</v-icon>
            </v-btn>
          </v-toolbar-items>
        </v-toolbar>
        <vue-perfect-scrollbar
          class="inbox-content-scroll"
          style="height:calc(100vh - 70px)"
          id="v-step-4"
        >
          <v-container grid-list-xs>
            <v-card>
              <v-container grid-list-xs pb-0>
                <span style="color:#002f87">Información del Usuario</span>
                <v-divider></v-divider>
              </v-container>
              <v-form v-model="valid" ref="validForm">
                <v-container style="padding-bottom:0px !important" grid-list-xs px-4>
                  <v-layout row wrap>
                    <v-flex xs12>
                      <v-select
                        :items="typeUser"
                        item-text="text"
                        item-value="value"
                        v-model="newUser.profile.type"
                        name="typeUser"
                        v-bind:label="$t('message.typeUser')"
                        v-validate="'required'"
                        :error-messages="errors.collect('typeUser')"
                      ></v-select>
                    </v-flex>
                    <v-flex xs12>
                      <!-- todos -->
                      <v-text-field
                      v-if="newUser.profile.type!='aps_admin'"
                        v-model="newUser.profile.user_id"
                        @blur="searchExternalAgent()"
                        name="userID"
                        v-bind:label="$t('message.userID')"
                        v-validate="'required'"
                        :error-messages="errors.collect('userID')"
                      ></v-text-field>
                    </v-flex>
                  </v-layout>
                </v-container>
                <component ref="formCreate" v-bind:is="newUser.profile.type"></component>
              </v-form>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-flex xs4>
                  <v-layout row wrap>
                    <v-flex xs5>
                      <v-btn @click="closeDialog()" color="default">Cancelar</v-btn>
                    </v-flex>
                    <v-spacer></v-spacer>
                    <v-flex xs5>
                      <v-btn color="accent" @click="createUser()">Guardar</v-btn>
                    </v-flex>
                  </v-layout>
                </v-flex>
            </v-card-actions>
            </v-card>
          </v-container>
        </vue-perfect-scrollbar>
      </v-card>
    </v-dialog>
  </v-container>
</template>
<script>
/* import gm from "gm"; */
import CatalogServices from "@/services/CatalogsServices";
import { mapGetters } from "vuex";
import ApsForm from "./ApsForm";
import ExecutiveForm from "./ExecutiveForm";
import AdminForm from "./AdminForm";
import PromotorForm from "./PromotorForm";
import { EventBus } from "@/imports/EventBus";
export default {
  components: {
    aps_broker: ApsForm,
    aps_executive:ExecutiveForm,
    aps_admin:AdminForm,
    aps_promotor:PromotorForm
  },
  data() {
    return {
      valid: false,
      typePersonEdit: false,
      applicantCatalogsCantonByProvince: [],
      insuredCatalogsCantonByProvince: [],
      cities: [],
      parishes: [],
      menu: false,
      menu1: false,
      menu2: false,
      dialog: false,
      typeUser: [
        { text: "APS", value: "aps_broker" },
        { text: "EJECUTIVO", value: "aps_executive" },
        { text: "ADMIN", value: "aps_admin" },
        { text: "PROMOTOR", value: "aps_promotor" }
      ],
       newUser: {
        email: undefined,
        password: undefined,
        profile: {
          user_id: undefined,
          institute_code:undefined,
          type: "aps_broker",
          identity: undefined,
          identity_type: "RUC",
          agencies: [],
          id_aps_sos: undefined,
          person_type: "NATURAL",
          first_name: undefined,
          second_name: undefined,
          first_surname: undefined,
          second_surname: undefined,
          business_name: undefined,
          birth_date: undefined,
          accreditation_date: undefined,
          nationality: undefined,
          gender: null,
          civil_status: undefined,
          country: "ECUADOR",
          canton: undefined,
          city: undefined,
          province: undefined,
          parish: undefined,
          home_address: undefined,
          email: undefined,
          personal_email: undefined,
          home_phone: undefined,
          cell_phone: undefined,
          office_phone: undefined,
          aps: undefined,
          office_address: undefined,
          notification_email: undefined,
          legal_representative: undefined,
          billing_email: undefined,
          office_email: undefined,
          creation_date: undefined,
          user_name: undefined,
          executives: [],
          id_aps_vt: undefined,
          web_page: undefined,
          postal_code: undefined
        }
      },
      rules: {
        required: value => !!value || "Campo Requerido",
        requiredS: value => value.length > 0 || "Campo Requerido",
        counter: value => value.length >= 2 || "Mínimo 2 caracteres",
        identification: value =>
          value.length == 10 || "Diez dígitos obligatorios",
        phoneNumber: value => value.length >= 10 || "Mínimo 10 digitos",
        email: value => {
          const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
          return pattern.test(value) || "Dirección email invalida";
        }
      }
    };
  },
  beforeDestroy() {
    EventBus.$off("closeDialog");
  },
  mounted() {
     EventBus.$on("closeDialog", () => {
     this.closeDialog();
     this.$store.dispatch("getUsers");
    });
    this.$refs.validForm.reset();
    this.$store.dispatch("getCatalogsProvince");
 
    this.$store.dispatch("getCatalogsCivilStatus");
    this.$store.dispatch("getCatalogsGender");
    this.$store.dispatch("getCatalogsNationality");
  },
  watch: {
    "newUser.profile.type"(val) {
      if (val == "aps_executive" || val == "aps_promotor") {
        this.newUser.profile.person_type = "NATURAL";
        this.typePersonEdit = true;
      } else {
        this.typePersonEdit = false;
        this.newUser.profile.person_type = "NATURAL";
      }
    }
  },
  computed: {
    ...mapGetters([
      "catalogsProvince",
      "catalogsCanton",
      "catalogsCity",
      "catalogsCivilStatus",
      "catalogsGender",
      "catalogsNacionalities"
    ])
  },
  methods: {
    changeProvince() {
      let resultSearch = this.catalogsProvince.find(
        obj => obj.code == this.newUser.profile.province
      );
      this.$store.dispatch("getCatalogsCanton", resultSearch.provinceCode);
      this.$store.dispatch(
        "getCatalogsCityByProvince",
        resultSearch.provinceCode
      );
    },
    async changeApplicantProvince() {
      if (this.newUser.profile.province) {
        let resultSearch = this.catalogsProvince.find(
          obj => obj.code == this.newUser.profile.province
        );
        CatalogServices.getCantonByProvince(resultSearch.provinceCode)
          .then(response => {
            this.applicantCatalogsCantonByProvince = response.data.data;
          })
          .catch(res => {
            this.$root.$emit("showSnackBar", "Error desconocido", "error");
          });
      } else {
        this.applicantCatalogsCantonByProvince = [];
      }
    },
    searchExternalAgent() {
      if (
        this.newUser.profile.user_id != "" &&
        this.newUser.profile.user_id != undefined
      ) {
        this.$root.$emit("showLoading", "Consultando");
        this.$store
          .dispatch("searchExternalAgent", this.newUser.profile.user_id)
          .then(res => {
            if (res.data.error == 100) {
              this.$root.$emit(
                "showSnackBar",
                "No existen datos para el id ingresado",
                "error"
              );
              this.newUser.profile.user_id=undefined;
              this.$root.$emit("hideLoading");
            } else {
                    this.$refs.formCreate.newUser= {
              email: undefined,
              password: undefined,
              profile: {
                institute_code:undefined,
                type: "aps_broker",
                identity: undefined,
                identity_type: "RUC",
                agencies: [],
                id_aps_sos: undefined,
                first_name: undefined,
                second_name: undefined,
                first_surname: undefined,
                second_surname: undefined,
                business_name: undefined,
                birth_date: undefined,
                accreditation_date: undefined,
                nationality: undefined,
                gender: null,
                civil_status: undefined,
                country: "ECUADOR",
                canton: undefined,
                city: undefined,
                province: undefined,
                parish: undefined,
                home_address: undefined,
                email: undefined,
                personal_email: undefined,
                home_phone: undefined,
                cell_phone: undefined,
                office_phone: undefined,
                aps: undefined,
                office_address: undefined,
                notification_email: undefined,
                legal_representative: undefined,
                billing_email: undefined,
                office_email: undefined,
                creation_date: undefined,
                user_name: undefined,
                executives: [],
                id_aps_vt: undefined,
                web_page: undefined,
                postal_code: undefined
              }
          }
              this.newUser.email = res.data.data.CorreoElectronico;
              if (res.data.data.Identificacion.length > 10) {
                this.newUser.password = res.data.data.Identificacion.substring(
                  0,
                  10
                );
              } else {
                this.newUser.password = res.data.data.Identificacion;
              }
              this.newUser.profile.identity = res.data.data.Identificacion;
              this.newUser.profile.agencies = res.data.data.ListaAgencias;
              this.newUser.profile.business_name = res.data.data.Nombre;
              this.newUser.profile.user_name = res.data.data.NombreUsuario;
              this.newUser.profile.id_aps_vt = res.data.data.IdApsVt;
              if (res.data.data.TipoPersona == "JURIDICO") {
                this.newUser.profile.person_type = "JURIDICO";
              } else {
                this.newUser.profile.person_type = "NATURAL";
                this.newUser.profile.first_name = res.data.data.PrimerNombre;
                this.newUser.profile.second_name = res.data.data.SegundoNombre;
                this.newUser.profile.first_surname = res.data.data.PrimerApellido;
                this.newUser.profile.second_surname = res.data.data.SegundoApellido;
              }
              if (this.newUser.profile.type == "aps_executive" || this.newUser.profile.type == "aps_promotor") {
                this.newUser.profile.institute_code = res.data.data.Identificacion;
                this.newUser.profile.aps = res.data.data.NombreUsuario;
              } else {
                this.newUser.profile.institute_code = res.data.data.NombreUsuario;
              }
              EventBus.$emit("searchExternalAgent", this.newUser);
              this.$root.$emit("hideLoading");
            }
          });
      }
    },
    createUser() {
      this.$validator.validateAll().then(success => {
          if(success){
            this.$refs.formCreate.checkEmail();
            
        }
      })
    },
    closeDialog(){
      //this.$refs.formCreate.errors.items=[];
      this.$refs.formCreate.errors.clear();
      this.newUser.profile.user_id=undefined;
     // console.log(this.$refs.formCreate)
      this.$refs.formCreate.newUser= {
        email: undefined,
        password: undefined,
        profile: {
          user_id: undefined,
          institute_code:undefined,
          type: "aps_broker",
          identity: undefined,
          identity_type: "RUC",
          agencies: [],
          id_aps_sos: undefined,
          person_type: "NATURAL",
          first_name: undefined,
          second_name: undefined,
          first_surname: undefined,
          second_surname: undefined,
          business_name: undefined,
          birth_date: undefined,
          accreditation_date: undefined,
          nationality: undefined,
          gender: null,
          civil_status: undefined,
          country: "ECUADOR",
          canton: undefined,
          city: undefined,
          province: undefined,
          parish: undefined,
          home_address: undefined,
          email: undefined,
          personal_email: undefined,
          home_phone: undefined,
          cell_phone: undefined,
          office_phone: undefined,
          aps: undefined,
          office_address: undefined,
          notification_email: undefined,
          legal_representative: undefined,
          billing_email: undefined,
          office_email: undefined,
          creation_date: undefined,
          user_name: undefined,
          executives: [],
          id_aps_vt: undefined,
          web_page: undefined,
          postal_code: undefined
        }
     }
      this.dialog=false;
      
    },
    saveDate(date) {
      this.$refs.menu.save(date);
    },
    saveDate1(date) {
      this.$refs.menu1.save(date);
    },
    saveDate2(date) {
      this.$refs.menu2.save(date);
    },
    removeEjecutive(item) {
      this.newUser.profile.executives.splice(
        this.newUser.profile.executives.indexOf(item),
        1
      );
      this.newUser.profile.executives = [...this.newUser.profile.executives];
    },
    open() {
  
     
      (this.newUser= {
        email: undefined,
        password: undefined,
        profile: {
          user_id: undefined,
          institute_code:undefined,
          type: "aps_broker",
          identity: undefined,
          identity_type: "RUC",
          agencies: [],
          id_aps_sos: undefined,
          person_type: "NATURAL",
          first_name: undefined,
          second_name: undefined,
          first_surname: undefined,
          second_surname: undefined,
          business_name: undefined,
          birth_date: undefined,
          accreditation_date: undefined,
          nationality: undefined,
          gender: null,
          civil_status: undefined,
          country: "ECUADOR",
          canton: undefined,
          city: undefined,
          province: undefined,
          parish: undefined,
          home_address: undefined,
          email: undefined,
          personal_email: undefined,
          home_phone: undefined,
          cell_phone: undefined,
          office_phone: undefined,
          aps: undefined,
          office_address: undefined,
          notification_email: undefined,
          legal_representative: undefined,
          billing_email: undefined,
          office_email: undefined,
          creation_date: undefined,
          user_name: undefined,
          executives: [],
          id_aps_vt: undefined,
          web_page: undefined,
          postal_code: undefined
        }
      }),
     
        (this.dialog = true);
    }
  }
};
</script>
